import React from 'react';
import './Loading.css';

interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'white';
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ 
  size = 'medium', 
  color = 'primary',
  text
}) => {
  return (
    <div className="loading-wrapper">
      <div className={`loading-spinner ${size} ${color}`}>
        <div className="spinner"></div>
      </div>
      {text && <div className="loading-text">{text}</div>}
    </div>
  );
};

export default Loading; 